import { render, staticRenderFns } from "./FormServer2Streamax.vue?vue&type=template&id=19b8214e&scoped=true&"
import script from "./FormServer2Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer2Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer2Streamax.vue?vue&type=style&index=0&id=19b8214e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8214e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('19b8214e', component.options)
    } else {
      api.reload('19b8214e', component.options)
    }
    module.hot.accept("./FormServer2Streamax.vue?vue&type=template&id=19b8214e&scoped=true&", function () {
      api.rerender('19b8214e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/ServerStreamax/FormServer2Streamax.vue"
export default component.exports